module.exports = __webpack_public_path__ + "img/home_ltc.bd4f34bb.png";